<template>
        <defaultSec :returnState="true">
            <template #title>
                <div  class="default-header" style="display: flex;justify-content: space-between">
                    <h3 v-if="editAble" style="cursor: pointer" @click="returnPage">&lt; 工单详情</h3>
                    <h3 v-else style="cursor: pointer">工单详情</h3>
                    <div>
                        <el-popover
                            v-if="workOrderInfo.workOrderFlowList.length>0"
                            trigger="hover"
                            placement="bottom"
                            width="400">
                            <el-alert style="margin-bottom: 20px" type="success" :closable="false">
                                <template #title>
                                    <i class="el-icon-s-flag"></i> 操作日志
                                </template>
                            </el-alert>
                            <div style="height: 350px;overflow-y: scroll">
                                <el-timeline size="small">
                                    <el-timeline-item
                                        v-for="(item, index) in workOrderInfo.workOrderFlowList"
                                        :key="index"
                                        color="#0bbd87"
                                        :timestamp="item.CREATE_TIME">
                                        <h4>{{item.action}}</h4>
                                        <p v-if="item.HANDLE_TEXT" style="color: #999999;font-size: 12px">备注：{{item.HANDLE_TEXT}}</p>
                                        <el-tag :type="item.EVENT_TYPE==1?'success':(item.EVENT_TYPE==4?'danger':(item.EVENT_TYPE==5?'warning':''))">{{item.EVENT_NAME}}</el-tag>
                                    </el-timeline-item>
                                </el-timeline>

                            </div>
                            <el-button type="warning" style="padding: 5px 10px" slot="reference" icon="el-icon-notebook-1">操作日志</el-button>
                        </el-popover>
                        <el-divider direction="vertical"></el-divider>

                        <template v-if="editAble">
                            <el-button
                                style="float: right; padding: 5px 10px"
                                type="danger"
                                :loading="saving"
                                :disabled="uploadingCount > 0"
                                @click="addWorkOrderSubmit">
                                {{uploadingCount > 0 ? '图片上传中' : '保存工单'}}
                            </el-button>
                            <el-button v-if="workOrderNo!=0 && workOrderInfo.workOrderStatus!=10 && workOrderInfo.workOrderStatus!=0" style="float: right; padding: 5px 10px;margin: 0 5px" type="primary" @click="handleWorkOrder(0)">关闭工单</el-button>
                            </template>
                        <template v-else>
                            <el-button style="float: right; padding: 5px 10px" type="danger" @click="handleWorkOrder(1)">处理工单</el-button>
                            <el-button style="float: right; padding: 5px 10px;margin: 0 5px" type="primary" @click="handleWorkOrder(2)">指派工单</el-button>
<!--                            <el-button style="float: right; padding: 5px 10px;" type="warning" @click="handleWorkOrder(3)">退回工单</el-button>-->
                        </template>
                    </div>

                </div>

            </template>
            <div class="work-order-detail-info" v-loading="loading">
                <el-tabs type="border-card">
                    <el-tab-pane label="工单信息">
                        <el-card
                            v-if="editAble && String(workOrderNo) === '0'"
                            class="ai-draft-card"
                            shadow="never">
                            <div slot="header" class="ai-draft-header">
                                <div>
                                    <span class="ai-draft-title"><i class="el-icon-magic-stick"></i> AI 识别工单</span>
                                    <span class="ai-draft-subtitle">粘贴聊天记录、订单信息和图片，识别后仅回填下方草稿</span>
                                </div>
                                <el-tag size="mini" type="warning">人工确认后提交</el-tag>
                            </div>
                            <el-input
                                v-model="aiInputText"
                                type="textarea"
                                :rows="5"
                                maxlength="8000"
                                show-word-limit
                                placeholder="可直接粘贴混合信息，例如：订单号、客户反馈、批次、希望生产确认的问题、已有沟通结果……"
                                @paste.native="handleAiPaste">
                            </el-input>
                            <div class="ai-draft-actions">
                                <div tabindex="0" class="ai-paste-zone" @paste="handleAiPaste">
                                    <i class="el-icon-document-copy"></i> 点击后粘贴图片
                                </div>
                                <el-upload
                                    :show-file-list="false"
                                    multiple
                                    accept="image/*"
                                    :action="''"
                                    :httpRequest="uploadAiImage">
                                    <el-button size="small" plain type="primary" :loading="aiUploadingCount > 0">
                                        上传图片（最多10张）
                                    </el-button>
                                </el-upload>
                                <el-button
                                    size="small"
                                    type="primary"
                                    icon="el-icon-magic-stick"
                                    :loading="aiRecognizing"
                                    :disabled="aiUploadingCount > 0"
                                    @click="recognizeAiDraft">
                                    {{aiUploadingCount > 0 ? '图片上传中' : '开始识别并回填'}}
                                </el-button>
                                <span class="ai-draft-tip">可只填文字或只传图片；识别过程不会创建、保存或提交工单。</span>
                            </div>
                            <div v-if="aiImages.length" class="ai-image-list">
                                <div v-for="(item,index) in aiImages" :key="item.url" class="ai-image-item">
                                    <el-image
                                        :src="item.url"
                                        class="ai-image"
                                        :preview-src-list="aiImageUrls">
                                    </el-image>
                                    <el-button
                                        class="ai-image-delete"
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        size="mini"
                                        title="删除图片"
                                        @click="removeAiImage(index)">
                                    </el-button>
                                </div>
                            </div>
                            <el-alert
                                v-if="aiResultVisible"
                                class="ai-result-alert"
                                title="AI 识别结果已回填到下方，请逐项核对后再保存工单"
                                type="success"
                                :closable="false"
                                show-icon>
                            </el-alert>
                            <div v-if="aiWarnings.length" class="ai-feedback-list">
                                <div class="ai-feedback-title">需要注意</div>
                                <div v-for="(item,index) in aiWarnings" :key="'warning-' + index" class="ai-warning-item">
                                    <i class="el-icon-warning-outline"></i> {{item}}
                                </div>
                            </div>
                            <div v-if="aiUnresolvedFields.length" class="ai-unresolved-fields">
                                <span>仍需人工补充：</span>
                                <el-tag
                                    v-for="item in aiUnresolvedFields"
                                    :key="item"
                                    size="mini"
                                    type="warning">
                                    {{aiFieldLabel(item)}}
                                </el-tag>
                            </div>
                        </el-card>
                        <el-alert style="margin: 10px 0"
                            title="关联信息"
                            type="success"
                            :closable="false">
                        </el-alert>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>

                            <el-descriptions-item label="购买渠道">
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 购买渠道
                                </template>
                                <el-radio-group :disabled="!editAble||workOrderNo!=0?true:false" size="mini" v-model="workOrderInfo.orderOnline">
                                    <el-radio :label="1">线上</el-radio>
                                    <el-radio :label="2">线下</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="联系人">
                                <el-input :disabled="!editAble?true:false" size="small" v-model="workOrderInfo.contactName" placeholder="请输入联系人" ></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item label="联系电话">
                                <el-input :disabled="!editAble?true:false" size="small" v-model="workOrderInfo.contactPhone" placeholder="请输入联系电话" ></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item label="联系地址">
                                <el-input :disabled="!editAble?true:false" size="small" v-model="workOrderInfo.contactAddr" placeholder="请输入联系地址" ></el-input>
                            </el-descriptions-item>
                            <template v-if="workOrderInfo.orderOnline==2">
                                <el-descriptions-item label="线下门店">
                                    <el-input :disabled="!editAble||String(workOrderNo)!=='0'?true:false" size="small" v-model="workOrderInfo.offlineShopName" placeholder="请输入线下门店信息" ></el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="线下单号">
                                    <el-input :disabled="!editAble||String(workOrderNo)!=='0'?true:false" size="small" v-model="workOrderInfo.offlineOrderNo" placeholder="请输入线下订单号" ></el-input>
                                </el-descriptions-item>
                            </template>
                            <template v-else-if="workOrderInfo.orderOnline==1">
                                <el-descriptions-item label="工单来源">
                                    <el-select :disabled="!editAble||String(workOrderNo)!=='0'?true:false" size="small" style="width: 100%" v-model="workOrderInfo.orderSource" placeholder="请选择">
                                        <el-option
                                            v-for="item in orderSourceList"
                                            :key="item.key"
                                            :label="item.name"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-descriptions-item>
                                <el-descriptions-item label="店铺">
                                    {{workOrderInfo.onlineShopName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="外部单号">
                                    <el-input :disabled="!editAble||String(workOrderNo)!=='0'?true:false" size="small" v-model="workOrderInfo.someID" placeholder="请输入外部单号的 订单号/售后单号" >
                                        <el-button  v-if="editAble&&String(workOrderNo)==='0'&&workOrderInfo.workOrderStatus!=10" size="small" slot="append" type="primary" @click="getOrder">获取订单明细</el-button>
                                    </el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="外部单号类型">
                                <span style="color: #209e91">
                                    {{relateTypeText(workOrderInfo.relateType)}}
                                </span>
                                </el-descriptions-item>
                            </template>

                            <el-descriptions-item label="商品温层">
                                <el-radio-group
                                    v-if="editAble && String(workOrderNo)==='0'"
                                    v-model="workOrderInfo.temperatureZone"
                                    size="mini"
                                    @change="handleTemperatureZoneChange">
                                    <el-radio-button label="COLD">低温</el-radio-button>
                                    <el-radio-button label="AMBIENT">常温</el-radio-button>
                                    <el-radio-button label="UNKNOWN">待确认</el-radio-button>
                                </el-radio-group>
                                <el-tag v-else :type="temperatureZoneTagType(workOrderInfo.temperatureZone)">
                                    {{temperatureZoneText(workOrderInfo.temperatureZone)}}
                                </el-tag>
                                <div class="field-tip">订单可识别时自动判定；数据缺失或冲突时，请人工确认。</div>
                            </el-descriptions-item>

                        </el-descriptions>
                        <el-alert style="margin: 20px 0 10px 0"
                                  title="基本信息"
                                  type="success"
                                  :closable="false">
                        </el-alert>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                            <el-descriptions-item label="售后问题">
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 售后问题
                                </template>
                                <el-cascader
                                    v-if="useStableClassification"
                                    size="small"
                                    :disabled="!editAble||String(workOrderNo)!=='0'?true:false"
                                    v-model="workOrderInfo.issueCode"
                                    placeholder="请选择两级售后问题"
                                    style="width: 100%"
                                    :options="issueOptions"
                                    :props="{emitPath:false}"
                                    @change="handleIssueChange">
                                    <template slot-scope="{ node, data }">
                                        <div>
                                            <span>{{ data.label }}</span>
                                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                        </div>
                                    </template>
                                </el-cascader>
                                <el-cascader
                                    v-else
                                    size="small"
                                    :disabled="!editAble||String(workOrderNo)!=='0'?true:false"
                                    v-model="workOrderInfo.workOrderTypeCode"
                                    placeholder="请选择历史售后类型"
                                    style="width: 100%"
                                    :options="legacyTypeOptions"
                                    :props="{emitPath:false}"
                                    @change="(val)=>handleWorkTypeChange(val,'workType')">
                                </el-cascader>
                                <div v-if="!useStableClassification" class="field-tip">
                                    该工单使用历史分类，保存时仍按原分类处理，不迁移历史数据。
                                </div>
                            </el-descriptions-item>
                            <template v-if="useStableClassification && isQualityIssue">
                                <el-descriptions-item label="产品线">
                                    <template slot="label">
                                        <span style="color: #e50011">*</span> 产品线
                                    </template>
                                    <el-select
                                        v-if="editAble && String(workOrderNo)==='0'"
                                        v-model="workOrderInfo.productLineCode"
                                        :disabled="!isSupportedTemperatureZone"
                                        filterable
                                        size="small"
                                        style="width: 100%"
                                        placeholder="请先确认温层"
                                        @change="handleProductLineChange">
                                        <el-option
                                            v-for="item in productLineOptions"
                                            :key="item.productLineCode"
                                            :label="item.productLineName"
                                            :value="item.productLineCode"
                                            :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{workOrderInfo.workOrderTypeMatClass || '-'}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="工厂">
                                    <template slot="label">
                                        <span style="color: #e50011">*</span> 工厂
                                    </template>
                                    <el-select
                                        v-if="editAble && String(workOrderNo)==='0'"
                                        v-model="workOrderInfo.factoryCode"
                                        :disabled="false"
                                        size="small"
                                        style="width: 100%"
                                        placeholder="请选择"
                                        @change="handleFactoryChange">
                                        <el-option
                                            v-for="item in factorySelectOptions"
                                            :key="item.factoryCode"
                                            :label="item.factoryName"
                                            :value="item.factoryCode"
                                            :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{workOrderInfo.workOrderTypeFactory || '-'}}</span>
                                    <div class="field-tip">工厂与产品线独立；工厂必选。</div>
                                </el-descriptions-item>
                            </template>
                            <el-descriptions-item v-if="useStableClassification && isOperationIssue" label="关联店铺">
                                <span>{{workOrderInfo.onlineShopName || '-'}}</span>
                                <el-tag v-if="workOrderInfo.shopCode" size="mini" type="info">{{workOrderInfo.shopCode}}</el-tag>
                                <div class="field-tip">店铺以订单数据为准，并自动匹配运营处理人。</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="处理人">
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 处理人
                                </template>
                                <el-select
                                    v-if="!useStableClassification"
                                    filterable
                                    :disabled="!editAble||String(workOrderNo)!=='0'?true:false"
                                    size="small"
                                    @change="(val)=>handleWorkTypeChange(val,'handleUserId')"
                                    style="width: 100%"
                                    v-model="workOrderInfo.handleUserId"
                                    placeholder="请选择">
                                    <el-option
                                        v-for="item in userList"
                                        :key="item.USER_ID"
                                        :label="userDisplayName(item)"
                                        :value="item.USER_ID">
                                    </el-option>
                                </el-select>
                                <template v-else-if="isQualityIssue && editAble && String(workOrderNo)==='0'">
                                    <el-select filterable size="small" style="width:100%" v-model="workOrderInfo.handleUserId" placeholder="请选择负责人">
                                        <el-option v-for="item in responsibleOptions" :key="item.responsibleUserId" :label="userNameById(item.responsibleUserId)" :value="item.responsibleUserId" />
                                    </el-select>
                                </template>
                                <template v-else>
                                    <el-tag v-if="workOrderInfo.handleUserId" type="success">{{userNameById(workOrderInfo.handleUserId)}}</el-tag>
                                    <span v-else class="route-warning">当前条件未匹配到处理人</span>
                                    <div class="field-tip">处理人由售后问题、质量路由或店铺路由自动确定，保存时服务端会再次校验。</div>
                                </template>
                                <div v-if="workOrderInfo.handleUserEmail" class="field-tip">邮箱：{{workOrderInfo.handleUserEmail}}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="创建人">
                                {{workOrderInfo.createUserName || userNameById(workOrderInfo.createUserId) || '-'}}
                            </el-descriptions-item>
                            <el-descriptions-item label="商品温层原值">
                                {{workOrderInfo.temperatureZoneOriginal || '-'}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 售后问题描述
                                </template>
                                <el-input type="textarea" style="width: 100%" :disabled="!editAble?true:false" size="small" v-model="workOrderInfo.workOrderDesc" placeholder="请输入售后问题描述" />
                            </el-descriptions-item>
                            <el-descriptions-item label="工单编号">
                                {{workOrderInfo.workOrderNo}}
                            </el-descriptions-item>
                            <el-descriptions-item label="创建时间">
                                {{workOrderInfo.createTime}}
                            </el-descriptions-item>
                            <el-descriptions-item label="创建人">
                                {{workOrderInfo.createUserId}}
                            </el-descriptions-item>
                            <el-descriptions-item label="沟通状态">
                                <el-select
                                    v-if="editAble"
                                    v-model="workOrderInfo.communicationStatus"
                                    size="small"
                                    style="width: 100%"
                                    placeholder="请选择沟通状态">
                                    <el-option
                                        v-for="item in communicationStatusOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="item.value === 'REPLIED' && !workOrderInfo.productionReply">
                                    </el-option>
                                </el-select>
                                <el-tag v-else :type="communicationStatusTagType(workOrderInfo.communicationStatus)">
                                    {{communicationStatusText(workOrderInfo.communicationStatus)}}
                                </el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="沟通结果">
                                <el-input
                                    v-if="editAble"
                                    v-model="workOrderInfo.communicationResult"
                                    type="textarea"
                                    :rows="3"
                                    placeholder="已有处理结论、退款/补发结果等，可直接填写在这里">
                                </el-input>
                                <span v-else class="pre-line-text">{{workOrderInfo.communicationResult || '-'}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="待生产回复问题">
                                <el-input
                                    v-if="editAble"
                                    v-model="workOrderInfo.productionQuestion"
                                    type="textarea"
                                    :rows="3"
                                    placeholder="需要生产同事判断或回复的问题；选择“待生产回复”时必填">
                                </el-input>
                                <span v-else class="pre-line-text">{{workOrderInfo.productionQuestion || '-'}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item  label="图片">
                                <el-alert
                                    v-if="isQualityIssue"
                                    class="picture-requirement"
                                    :title="pictureRequirementText"
                                    :type="missingPictureWarning ? 'warning' : 'success'"
                                    :closable="false"
                                    show-icon>
                                </el-alert>
                                <div class="picture-upload-row" v-if="editAble && String(workOrderNo)==='0'">
                                    <el-select v-model="newPictureCategory" size="small" style="width: 130px">
                                        <el-option
                                            v-for="item in pictureCategoryOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <div tabindex="0" @paste="pasteImgFun" class="paste-wrap">点击后粘贴</div>
                                    <span>或</span>
                                    <el-upload
                                        :show-file-list="false"
                                        multiple
                                        class="upload-demo"
                                        :action="''"
                                        :httpRequest="(file)=>uploadFile(file,'order')"
                                        :file-list="fileList">
                                        <el-button size="small" type="primary" :loading="uploadingCount > 0">本地上传</el-button>
                                    </el-upload>
                                </div>

                                <div class="picture-list">
                                    <div
                                        v-for="(item,index) in workOrderInfo.workOrderPics||[]"
                                        :key="item.picUrl + '-' + index"
                                        class="picture-item">
                                        <el-image
                                            :src="item.picUrl"
                                            class="picture-image"
                                            :preview-src-list="workOrderPictureUrls">
                                        </el-image>
                                        <el-tag size="mini">{{pictureCategoryText(item.picCategory)}}</el-tag>
                                        <el-button
                                            v-if="editAble"
                                            class="picture-delete"
                                            type="danger"
                                            icon="el-icon-delete"
                                            circle
                                            size="mini"
                                            title="删除图片"
                                            @click="removeWorkOrderPic(index)">
                                        </el-button>
                                    </div>
                                </div>

                            </el-descriptions-item>
                        </el-descriptions>
                        <el-alert style="margin: 20px 0 10px 0"
                                  title="处理结果"
                                  type="success"
                                  :closable="false">
                        </el-alert>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                            <el-descriptions-item label="工单状态">
                                <span :style="{color: workOrderInfo.workOrderStatus==0?'#999999':(workOrderInfo.workOrderStatus==1?'#dfb81d':(workOrderInfo.workOrderStatus==10?'green':'#e85656'))}">● {{workOrderInfo.workOrderStatusName}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="责任部门">
                                {{workOrderInfo.responsibleDeptName || workOrderInfo.responsibleDeptDingdingId || '-'}}
                            </el-descriptions-item>
                            <el-descriptions-item label="处理结果">
                                {{workOrderInfo.workOrderResult}}
                            </el-descriptions-item>
                            <el-descriptions-item label="理赔金额">
                                {{workOrderInfo.compensationAmount}}
                            </el-descriptions-item>
                            <el-descriptions-item label="关闭工单原因">
                                {{workOrderInfo.workOrderResultDesc}}
                            </el-descriptions-item>
                            <el-descriptions-item label="关闭时间">
                                {{workOrderInfo.closeTime}}
                            </el-descriptions-item>
                            <el-descriptions-item label="生产回复">
                                <div v-if="workOrderInfo.productionReply" class="production-reply">
                                    <div class="pre-line-text">{{workOrderInfo.productionReply}}</div>
                                    <div class="field-tip">
                                        回复人：{{workOrderInfo.productionReplyUserName || workOrderInfo.productionReplyUserId || '-'}}
                                        <span v-if="workOrderInfo.productionReplyTime">，{{workOrderInfo.productionReplyTime}}</span>
                                    </div>
                                </div>
                                <span v-else>暂无回复</span>
                            </el-descriptions-item>
                            <el-descriptions-item
                                v-if="workOrderNo != 0 && workOrderInfo.workOrderStatus != 0 && workOrderInfo.workOrderStatus != 10"
                                label="提交生产回复">
                                <el-input
                                    v-model="productionReplyInput"
                                    type="textarea"
                                    :rows="3"
                                    placeholder="仅当前处理人可提交；提交后会通知工单发起人">
                                </el-input>
                                <el-button
                                    style="margin-top: 8px"
                                    type="primary"
                                    size="small"
                                    :loading="productionReplySaving"
                                    @click="submitProductionReply">
                                    提交生产回复
                                </el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="处理日志">
                                <div style="height: 350px;overflow-y: scroll">
                                    <el-timeline size="small">
                                        <el-timeline-item
                                            v-for="(item, index) in workOrderInfo.workOrderFlowList"
                                            :key="index"
                                            color="#0bbd87"
                                            :timestamp="item.CREATE_TIME">
                                            <h5 style="margin: 10px 0">{{item.action}}</h5>
                                            <p v-if="item.HANDLE_TEXT" style="color: #999999;font-size: 12px">备注：{{item.HANDLE_TEXT}}</p>
                                            <el-tag size="mini" :type="item.EVENT_TYPE==1?'success':(item.EVENT_TYPE==4?'danger':(item.EVENT_TYPE==5?'warning':''))">{{item.EVENT_NAME}}</el-tag>
                                        </el-timeline-item>
                                    </el-timeline>

                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                        <template v-if="workOrderInfo.workOrderProductList.length>0">
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="售后商品 （* 已选中的是需要售后的商品）"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-table ref="salesProTable" border :data="workOrderInfo.workOrderProductList"
                                      style="width: 100%"
                                      size="mini"
                                      @selection-change="handleSelectionChange"
                            >
                                <el-table-column
                                            :selectable="()=>editAble && String(workOrderNo)==='0'"
                                    type="selection"
                                    width="40">
                                </el-table-column>
                                <el-table-column type="index" width="50" label="序号"></el-table-column>
                                <el-table-column prop="barCode" label="69码"></el-table-column>
                                <el-table-column prop="productCode" label="物品编码"></el-table-column>
                                <el-table-column label="商品名称" min-width="280">
                                    <template slot-scope="scope">
                                        <div>{{scope.row.productName}}</div>
                                        <div v-if="scope.row.onlineProductName" style="color:#e6a23c;font-size:12px;line-height:20px;">
                                            套装名：{{scope.row.onlineProductName}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="发货仓">
                                    <template slot-scope="scope">
                                        {{scope.row.dispatchStoreName || scope.row.factoryName || '-'}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="pici" label="批次"></el-table-column>
                                <el-table-column label="物流">
                                    <template slot-scope="scope">
                                        {{scope.row.logisticName}}
                                        {{scope.row.wayNo?'('+scope.row.wayNo+'）':''}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="workOrderDesc" label="图片">
                                    <template slot-scope="scope">
                                        <div class="product-picture-list">
                                            <div
                                                v-for="(item,index) in scope.row.picList||[]"
                                                :key="item + '-' + index"
                                                class="product-picture-item">
                                                <el-image
                                                    :src="item"
                                                    class="product-picture-image"
                                                    :preview-src-list="scope.row.picList">
                                                </el-image>
                                                <el-button
                                                    v-if="editAble"
                                                    class="product-picture-delete"
                                                    type="danger"
                                                    icon="el-icon-delete"
                                                    circle
                                                    size="mini"
                                                    title="删除图片"
                                                    @click="removeProductPic(scope.row,index)">
                                                </el-button>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                    <el-table-column width="250" v-if="editAble && String(workOrderNo)==='0'" prop="workOrderDesc" label="操作">
                                    <template slot-scope="scope">
                                        <div style="display: flex;align-items: center">
                                            <div tabindex="0" @paste="(event)=>pasteImgFun(event,scope.row)" class="paste-wrap">点击后粘贴</div>

                                            <span style="margin: 0 10px">或 </span>
                                            <el-upload
                                                :show-file-list="false"
                                                multiple
                                                class="upload-demo"
                                                :action="''"
                                                :httpRequest="(file)=>uploadFile(file,scope.row)"
                                                :file-list="fileList">
                                                <el-button size="mini" plain type="primary" :loading="uploadingCount > 0">本地上传</el-button>
                                            </el-upload>
                                        </div>

                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>


                    </el-tab-pane>
                    <el-tab-pane label="订单信息">
                        <template v-if="Object.keys(orderDetailInfo).length > 0">
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="基本信息"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                <el-descriptions-item label="店铺">
                                    {{orderDetailInfo.shopName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信主单号">
                                    {{orderDetailInfo.orderMainNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="子单号/外部订单号">
                                    {{orderDetailInfo.orderNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="订单状态">
                                    {{orderDetailInfo.orderStatusName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="订单类型">
                                    {{orderDetailInfo.orderTypeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="订单分类">
                                    {{orderDetailInfo.orderSonTypeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="冷链/常温">
                                    {{orderDetailInfo.orderIsCwName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="是否流转">
                                    {{orderDetailInfo.orderFlowSignName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="流转异常原因">
                                    {{orderDetailInfo.flowErroMessage}}
                                </el-descriptions-item>
                                <el-descriptions-item label="是否挂起">
                                    {{orderDetailInfo.isPending == 1 ? '是' : '否'}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信订单来源">
                                    {{orderDetailInfo.orderSourceName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信来源主单号">
                                    {{orderDetailInfo.sourceOrderMainNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信订单分类">
                                    {{orderDetailInfo.orderClassName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="购买人昵称">
                                    <p v-if="isWeixinOrder && orderDetailInfo.buyerId != 'csms-manual-order-creator'" @click="toBuyer(orderDetailInfo.buyerId)" style="text-decoration:underline;color:#0000ff;">{{orderDetailInfo.buyerName}}</p>
                                    <p v-if="!(isWeixinOrder && orderDetailInfo.buyerId != 'csms-manual-order-creator')">{{orderDetailInfo.buyerName}}</p>
                                </el-descriptions-item>
                                <el-descriptions-item label="支付时间">
                                    {{orderDetailInfo.payTime}}
                                </el-descriptions-item>
                                <el-descriptions-item label="备注">
                                    {{orderDetailInfo.remark}}
                                </el-descriptions-item>
                            </el-descriptions>
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="支付信息"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                <el-descriptions-item label="订单金额">
                                    {{orderDetailInfo.orderAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="运费">
                                    {{orderDetailInfo.freight}}
                                </el-descriptions-item>
                                <el-descriptions-item v-if="this.isWeixinOrder" label="现金支付">
                                    {{orderDetailInfo.cashAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item v-if="!this.isWeixinOrder" label="支付金额">
                                    {{orderDetailInfo.payAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="优惠券">
                                    {{orderDetailInfo.orderCouponAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="奶卡支付金额" :span="3">
                                    <template v-if="orderDetailInfo.specialCardPayDetails && orderDetailInfo.specialCardPayDetails.length > 0">
                                        <div class="special-card-pay-list">
                                            <el-tag
                                                v-for="item in orderDetailInfo.specialCardPayDetails"
                                                :key="item.cardNo"
                                                type="success"
                                                size="mini"
                                            >
                                                奶卡号{{item.cardNo}}：{{formatAmount(item.payAmount)}}
                                            </el-tag>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{formatAmount(orderDetailInfo.specialCardPoint)}}
                                    </template>
                                </el-descriptions-item>
                                <el-descriptions-item label="余额支付总额" :span="3">
                                    {{orderDetailInfo.balanceAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="余额储值部分">
                                    {{orderDetailInfo.balanceStoreAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="余额赠送部分">
                                    {{orderDetailInfo.balanceFreeAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="余额礼品卡部分">
                                    {{orderDetailInfo.balanceGiftAmount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="微信交易号">
                                    {{orderDetailInfo.wechatPaySerialNo}}
                                </el-descriptions-item>
                                <el-descriptions-item label="商户单号">
                                    {{orderDetailInfo.wechatPayTradeNo}}
                                </el-descriptions-item>
                            </el-descriptions>
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="配送信息"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                                <el-descriptions-item label="提货日期">
                                    {{orderDetailInfo.pickupDate}}
                                </el-descriptions-item>
                                <el-descriptions-item label="配送日期">
                                    {{orderDetailInfo.deliverDate}}
                                </el-descriptions-item>
                                <el-descriptions-item label="发货仓">
                                    {{orderDetailInfo.storeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="收货人">
                                    {{orderDetailInfo.consigneeName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="收货电话">
                                    {{orderDetailInfo.consigneePhone}}
                                </el-descriptions-item>
                                <el-descriptions-item label="详细地址">
                                    {{orderDetailInfo.consigneeAddrEntire}}
                                </el-descriptions-item>
                                <el-descriptions-item label="物流公司">
                                    {{orderDetailInfo.wayName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="物流单号">
                                    {{orderDetailInfo.wayNo}}
                                </el-descriptions-item>
                                <el-descriptions-item v-if="orderDetailInfo.wayNo != null && orderDetailInfo.wayNo != ''" label="物流信息">
                                    <el-timeline>
                                        <el-timeline-item
                                            v-for="(activity, index) in routers"
                                            :key="index"
                                            :timestamp="activity.time">
                                            {{activity.context}}
                                        </el-timeline-item>
                                    </el-timeline>
                                </el-descriptions-item>
                            </el-descriptions>
                            <el-alert style="margin: 20px 0 10px 0"
                                      title="退款记录"
                                      type="success"
                                      :closable="false">
                            </el-alert>
                            <el-table size="mini" :data="orderDetailInfo.orderRefundDetails" style="width: 100%">
                                <el-table-column prop="refundNo" label="退款单号" width="180"></el-table-column>
                                <el-table-column prop="refundType" label="退款类型" width="180"></el-table-column>
                                <el-table-column prop="afterSaleType" label="售后类型"></el-table-column>
                                <el-table-column prop="refundAmountCheck" label="退款金额"></el-table-column>
                                <el-table-column prop="refundStatus" label="状态"></el-table-column>
                                <el-table-column prop="refundReason" label="原因"></el-table-column>
                                <el-table-column prop="createId" label="操作人"></el-table-column>
                                <el-table-column prop="createTime" label="申请时间"></el-table-column>
                            </el-table>
                        </template>
                        <el-empty v-else :image-size="200" description="暂无订单信息"></el-empty>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-dialog
                width="80%"
                :title="handleTitle"
                :visible="addWorkOrderVisible"
                :before-close="handleClose">
                <el-form ref="form" :model="formData" label-width="90px" class="draw-box">
                    <template v-if="handleWorkType == 0">
                        <el-form-item label="责任部门" required>
                            <el-select filterable style="width: 100%" v-model="formData.dingDeptId" placeholder="请选择">
                                <el-option
                                    v-for="item in deptList"
                                    :key="item.key"
                                    :label="item.name"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="理赔金额">
                            <el-input v-model="formData.compensationAmount" placeholder="请输入理赔金额" />
                        </el-form-item>
                        <el-form-item label="处理结果" required>
                            <el-select style="width: 100%" v-model="formData.workOrderResult" placeholder="请选择">
                                <el-option
                                    v-for="item in workResultList"
                                    :key="item.key"
                                    :label="item.name"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-form-item v-if="handleWorkType==2" label="转给" required>
                        <el-select filterable style="width: 100%" v-model="formData.toUserId" placeholder="请选择要指派的处理人">
                            <el-option
                                v-for="item in userList"
                                :key="item.USER_ID"
                                :label="item.USER_NAME"
                                :value="item.USER_ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="handleList[handleWorkType]?handleList[handleWorkType].textLabel:'备注'" required>
                        <el-input type="textarea" v-model="formData.text" placeholder="请输入" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleWorkOrderSubmit">立即保存</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    export default {
        data() {
            return {
                loading:false,
                resourceUrl: process.env.VUE_APP_API_PATH,
                orderDetailInfo:{},
                workOrderInfo:{
                    orderOnline:1,
                    temperatureZone:'UNKNOWN',
                    temperatureZoneOriginal:'',
                    createUserName:'',
                    handleUserName:'',
                    handleUserEmail:'',
                    responsibleDeptName:'',
                    communicationStatus:'NO_REPLY_REQUIRED',
                    communicationResult:'',
                    productionQuestion:'',
                    productionReply:'',
                    workOrderPics:[],
                    workOrderProductList:[],
                    workOrderFlowList:[],
                },
                formData:{},
                workOrderNo: this.$route.params.id,
                classificationMode:String(this.$route.params.id) === '0' ? 'stable' : 'legacy',
                userList:[],
                deptList:[],
                issueOptions:[],
                legacyTypeOptions:[],
                productLineOptions:[],
                factoryOptions:[],
                originalStableSelection:null,
                originalRelationSelection:null,
                resolvedRelationSomeID:'',
                fileList:[],
                workOrderProductList:[],
                isWeixinOrder: true,
                editAble:this.$route.query.editAble?true:false,
                addWorkOrderVisible:false,
                handleWorkType:'',
                handleList:[
                    {key:0,title:'关闭工单',apiUrl:'lechun-csms/workOrder/closeWorkOrder',textLabel:'处理结果描述'},
                    {key:1,title:'处理工单',apiUrl:'lechun-csms/workOrder/handleWorkOrder',textLabel:'如何处理'},
                    {key:2,title:'指派工单',apiUrl:'lechun-csms/workOrder/forwardWorkOrder',textLabel:'指派原因'},
                    {key:3,title:'退回工单',apiUrl:'lechun-csms/workOrder/returnWorkOrder',textLabel:'退回原因'},
                ],
                //关联类型：0无关联，1订单，2售后单，3微信客户
                relateTypeList:[
                    {key:0,title:'无关联'},
                    {key:1,title:'关联订单'},
                    {key:2,title:'关联售后单'},
                    {key:3,title:'关联微信用户'},
                ],
                handleTitle:'工单',
                logList: [],
                multipleSelProList: [],
                workResultList: [],
                orderSourceList: [],
                pasteImg:"",
                saving:false,
                productionReplySaving:false,
                uploadingCount:0,
                aiInputText:'',
                aiImages:[],
                aiRecognizing:false,
                aiUploadingCount:0,
                aiWarnings:[],
                aiUnresolvedFields:[],
                aiResultVisible:false,
                saveRequestToken:'',
                replyRequestToken:'',
                productionReplyInput:'',
                draftStorageKey:'csms-work-order-create-draft-v1',
                draftTtlMs:2 * 60 * 60 * 1000,
                draftSaveTimer:null,
                draftReady:false,
                componentDestroyed:false,
                resizeHandler:null,
                workOrderRequestSeq:0,
                issueRequestSeq:0,
                productLineRequestSeq:0,
                factoryRequestSeq:0,
                shopRouteRequestSeq:0,
                newPictureCategory:'PRODUCT_STATUS',
                routers:[],
                pictureCategoryOptions:[
                    {value:'OUTER_PACKAGE',label:'外包装'},
                    {value:'PRODUCT_STATUS',label:'产品状态'},
                    {value:'BATCH',label:'批次'},
                    {value:'OTHER',label:'其他'},
                ],
                communicationStatusOptions:[
                    {value:'PENDING_REPLY',label:'待生产回复'},
                    {value:'REPLIED',label:'生产已回复'},
                    {value:'RESULT_AVAILABLE',label:'已有沟通结果'},
                    {value:'NO_REPLY_REQUIRED',label:'无需生产回复'},
                ],
                columnsCount:2,
                clientWidth:document.body.clientWidth,
                labelStyle:{
                    width: '100px',
                },
                // contentStyle:{
                //     width: 'calc(100% - 100px)',
                // },

            }
        },
        components:{
            defaultSec,
        },
        computed:{
            useStableClassification(){
                return this.classificationMode === 'stable'
            },
            selectedIssue(){
                return this.findWorkTypeNode(this.issueOptions,this.workOrderInfo.issueCode)
            },
            isQualityIssue(){
                return (this.selectedIssue && this.selectedIssue.issueGroupCode === 'QUALITY')
                    || (!this.selectedIssue && this.workOrderInfo.workOrderTypeGroup === '质量')
            },
            isOperationIssue(){
                return (this.selectedIssue && this.selectedIssue.issueGroupCode === 'OPERATION')
                    || (!this.selectedIssue && this.workOrderInfo.workOrderTypeGroup === '运营')
            },
            isSupportedTemperatureZone(){
                return ['COLD','AMBIENT'].indexOf(this.workOrderInfo.temperatureZone) > -1
            },
            responsibleOptions(){
                const code = this.workOrderInfo.factoryCode
                return (this.factoryOptions || []).filter(item => item.factoryCode === code)
            },
            factorySelectOptions(){
                const seen = {}
                return (this.factoryOptions || []).filter(item => {
                    if(seen[item.factoryCode]) return false
                    seen[item.factoryCode] = true
                    return true
                })
            },
            workOrderPictureUrls(){
                return (this.workOrderInfo.workOrderPics || []).map(item => item.picUrl).filter(Boolean)
            },
            aiImageUrls(){
                return this.aiImages.map(item => item.url).filter(Boolean)
            },
            missingPictureWarning(){
                if(!this.isQualityIssue) return ''
                const categories = (this.workOrderInfo.workOrderPics || []).map(item => item.picCategory)
                const missing = []
                if(this.workOrderInfo.temperatureZone === 'COLD'){
                    if(categories.indexOf('PRODUCT_STATUS') === -1) missing.push('产品状态图片')
                    if(categories.indexOf('BATCH') === -1) missing.push('批次图片')
                }else if(this.workOrderInfo.temperatureZone === 'AMBIENT'){
                    if(categories.indexOf('OUTER_PACKAGE') === -1) missing.push('外包装图片')
                    if(categories.indexOf('PRODUCT_STATUS') === -1) missing.push('产品状态图片')
                    if(categories.indexOf('BATCH') === -1) missing.push('批次图片')
                }
                if(missing.length === 0) return ''
                return `${this.temperatureZoneText(this.workOrderInfo.temperatureZone)}商品还缺少：${missing.join('、')}`
            },
            pictureRequirementText(){
                if(!this.isQualityIssue) return '非质量问题不要求质量判定图片，可按实际需要上传'
                if(this.workOrderInfo.temperatureZone === 'AMBIENT'){
                    return this.missingPictureWarning || '常温商品图片已齐全：外包装、产品状态、批次'
                }
                if(this.workOrderInfo.temperatureZone === 'COLD'){
                    return this.missingPictureWarning || '低温商品图片已齐全：产品状态、批次'
                }
                return '温层待确认：建议先上传产品状态和批次图片，确认温层后系统会提示缺失项'
            },
        },
        watch:{
            workOrderInfo:{
                deep:true,
                handler(){
                    this.scheduleDraftSave()
                },
            },
        },
        mounted(){
            if(this.clientWidth<500){
                this.columnsCount = 1
            }else{
                this.columnsCount = 2
            }
            this.resizeHandler = ()=>{
                if(this.componentDestroyed) return
                this.clientWidth =document.body.clientWidth
                if(this.clientWidth<500){
                    this.columnsCount = 1
                }else{
                    this.columnsCount = 2
                }
            }
            window.addEventListener('resize',this.resizeHandler)
            if(this.$route.params.id!=0){
                this.loading = true
                this.initList()
            }else{
                this.restoreDraft()
            }
            this.initUserList()
            this.initIssueOptions()
            this.initLegacyTypeList()
            this.initOrderSourceList()

        },
        beforeDestroy(){
            this.componentDestroyed = true
            this.workOrderRequestSeq += 1
            this.issueRequestSeq += 1
            this.productLineRequestSeq += 1
            this.factoryRequestSeq += 1
            this.shopRouteRequestSeq += 1
            if(this.resizeHandler){
                window.removeEventListener('resize',this.resizeHandler)
            }
            if(this.draftSaveTimer){
                clearTimeout(this.draftSaveTimer)
            }
        },
        methods: {
            formatAmount(value){
                if(value === null || value === undefined || value === ''){
                    return '-';
                }
                const amount = Number(value);
                return Number.isNaN(amount) ? value : amount.toFixed(2);
            },
            relateTypeText(value){
                const item = this.relateTypeList.find(option => option.key === Number(value))
                return item ? item.title : '无关联'
            },
            temperatureZoneText(value){
                return {COLD:'低温',AMBIENT:'常温',UNKNOWN:'待确认'}[value] || '待确认'
            },
            temperatureZoneTagType(value){
                return {COLD:'',AMBIENT:'success',UNKNOWN:'warning'}[value] || 'warning'
            },
            communicationStatusText(value){
                const item = this.communicationStatusOptions.find(option => option.value === value)
                return item ? item.label : '未设置'
            },
            communicationStatusTagType(value){
                return {
                    PENDING_REPLY:'warning',
                    REPLIED:'success',
                    RESULT_AVAILABLE:'',
                    NO_REPLY_REQUIRED:'info',
                }[value] || 'info'
            },
            pictureCategoryText(value){
                const item = this.pictureCategoryOptions.find(option => option.value === value)
                return item ? item.label : '其他'
            },
            aiFieldLabel(value){
                return {
                    someID:'外部单号',
                    issueCode:'售后问题',
                    temperatureZone:'商品温层',
                    productLineCode:'产品线',
                    factoryCode:'工厂',
                    shopCode:'店铺',
                    handleUserId:'处理人',
                    workOrderDesc:'售后问题描述',
                    communicationResult:'沟通结果',
                    productionQuestion:'待生产回复问题',
                    orderRelation:'订单关联信息',
                }[value] || value
            },
            userDisplayName(user){
                return user ? (user.USER_NAME || user.USER_NICK || user.USER_ID) : '-'
            },
            userNameById(userId){
                const user = this.userList.find(item => String(item.USER_ID) === String(userId))
                return user ? this.userDisplayName(user) : (userId || '-')
            },
            normalizeWorkOrderInfo(info){
                const source = info || {}
                const workOrderPics = source.workOrderPics && source.workOrderPics.length > 0
                    ? source.workOrderPics.map((item,index) => ({
                        ...item,
                        picCategory:item.picCategory || 'OTHER',
                        picIndex:item.picIndex || index + 1,
                    }))
                    : (source.picList || []).map((picUrl,index) => ({
                        picUrl,
                        picCategory:'OTHER',
                        picIndex:index + 1,
                    }))
                const products = (source.workOrderProductList || []).map(item => ({
                    ...item,
                    picList:item.picList || [],
                }))
                let communicationStatus = source.communicationStatus
                if(!communicationStatus){
                    if(source.productionReply) communicationStatus = 'REPLIED'
                    else if(source.productionQuestion) communicationStatus = 'PENDING_REPLY'
                    else if(source.communicationResult) communicationStatus = 'RESULT_AVAILABLE'
                    else communicationStatus = 'NO_REPLY_REQUIRED'
                }
                let workOrderTypeCode = source.workOrderTypeCode
                if(workOrderTypeCode !== null && workOrderTypeCode !== undefined && workOrderTypeCode !== ''){
                    workOrderTypeCode = Number(workOrderTypeCode)
                }
                return {
                    orderOnline:1,
                    issueCode:'',
                    productLineCode:'',
                    factoryCode:'',
                    shopCode:'',
                    communicationResult:'',
                    productionQuestion:'',
                    productionReply:'',
                    ...source,
                    workOrderTypeCode,
                    temperatureZone:source.temperatureZone || 'UNKNOWN',
                    temperatureZoneOriginal:source.temperatureZoneOriginal || '',
                    createUserName:source.createUserName || '',
                    handleUserName:source.handleUserName || '',
                    handleUserEmail:source.handleUserEmail || '',
                    responsibleDeptName:source.responsibleDeptName || '',
                    communicationStatus,
                    workOrderPics,
                    workOrderProductList:products,
                    workOrderFlowList:source.workOrderFlowList || [],
                }
            },
            mergeRelatedWorkOrderInfo(relatedInfo,preserveSnapshot){
                const source = relatedInfo || {}
                if(preserveSnapshot){
                    return this.normalizeWorkOrderInfo({
                        ...this.workOrderInfo,
                        someID:source.someID || this.workOrderInfo.someID,
                    })
                }
                const relatedSnapshot = {
                    someID:source.someID || this.workOrderInfo.someID,
                    relateType:source.relateType === null || source.relateType === undefined
                        ? 0 : source.relateType,
                    orderNo:source.orderNo || '',
                    refundNo:source.refundNo || '',
                    customerId:source.customerId || '',
                    orderOnline:source.orderOnline === null || source.orderOnline === undefined
                        ? 1 : source.orderOnline,
                    orderSource:source.orderSource || '',
                    onlineShopName:source.onlineShopName || '',
                    offlineShopName:source.offlineShopName || '',
                    offlineOrderNo:source.offlineOrderNo || '',
                    contactName:source.contactName || '',
                    contactPhone:source.contactPhone || '',
                    contactAddr:source.contactAddr || '',
                    temperatureZone:source.temperatureZone || 'UNKNOWN',
                    shopCode:source.shopCode || '',
                    workOrderProductList:source.workOrderProductList || [],
                }
                return this.normalizeWorkOrderInfo({
                    ...this.workOrderInfo,
                    ...relatedSnapshot,
                })
            },
            normalizeRouters(wayNos){
                return (wayNos || []).reduce((all,item) => {
                    if(Array.isArray(item)) return all.concat(item)
                    if(item && Array.isArray(item.data)) return all.concat(item.data)
                    if(item && Array.isArray(item.routers)) return all.concat(item.routers)
                    if(item && Array.isArray(item.traces)) return all.concat(item.traces)
                    if(item && (item.time || item.context)) all.push(item)
                    return all
                },[])
            },
            syncProductSelection(){
                const chosen = (this.workOrderInfo.workOrderProductList || []).filter(item => item.isChosen === 1)
                this.multipleSelProList = chosen
                this.$nextTick(() => {
                    if(this.componentDestroyed) return
                    const table = this.$refs.salesProTable
                    if(!table) return
                    table.clearSelection()
                    chosen.forEach(item => table.toggleRowSelection(item,true))
                })
            },
            initList(from) {
                const requestSeq = ++this.workOrderRequestSeq
                const requestedSomeID = from === 'getOrder'
                    ? String(this.workOrderInfo.someID || '').trim() : ''
                const relationChanged = from === 'getOrder'
                    && Boolean(this.resolvedRelationSomeID)
                    && requestedSomeID !== this.resolvedRelationSomeID
                if(relationChanged){
                    this.orderDetailInfo = {}
                    this.routers = []
                    this.clearQualityRouteSelection()
                    if(this.useStableClassification && this.isOperationIssue){
                        this.clearClassificationRoute()
                    }
                    this.workOrderInfo = this.normalizeWorkOrderInfo({
                        ...this.workOrderInfo,
                        relateType:0,
                        orderNo:'',
                        refundNo:'',
                        customerId:'',
                        orderSource:'',
                        onlineShopName:'',
                        offlineShopName:'',
                        offlineOrderNo:'',
                        contactName:'',
                        contactPhone:'',
                        contactAddr:'',
                        temperatureZone:'UNKNOWN',
                        shopCode:'',
                        workOrderProductList:[],
                    })
                    this.syncProductSelection()
                }
                let apiUrl
                let param
                if(from=='getOrder'){
                    apiUrl = 'lechun-csms/workOrder/getWorkOrderRelateInfo'
                    param = {
                        someID:requestedSomeID,
                        workOrderNo:this.workOrderInfo.workOrderNo || this.workOrderNo,
                    }
                }else{
                    apiUrl = 'lechun-csms/workOrder/workOrderDetail'
                    param = {workOrderNo:this.workOrderNo}
                }
                this.loading = true
                this.$apiGet(apiUrl,param).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.workOrderRequestSeq) return
                    this.loading = false
                    if(from === 'getOrder'
                        && requestedSomeID !== String(this.workOrderInfo.someID || '').trim()) return
                    const relatedInfo = res.workOrderInfo || {}
                    if(from === 'getOrder'){
                        const preserveSnapshot = this.shouldPreserveRelationSnapshot(relatedInfo)
                        if(!preserveSnapshot){
                            this.orderDetailInfo = res.orderDetail || {}
                            this.routers = this.normalizeRouters(res.wayNos)
                        }
                        this.workOrderInfo = this.mergeRelatedWorkOrderInfo(relatedInfo,preserveSnapshot)
                        this.resolvedRelationSomeID = requestedSomeID
                    }else{
                        this.orderDetailInfo = res.orderDetail || {}
                        this.routers = this.normalizeRouters(res.wayNos)
                        this.classificationMode = relatedInfo.issueCode ? 'stable' : 'legacy'
                        this.workOrderInfo = this.normalizeWorkOrderInfo(relatedInfo)
                        this.originalStableSelection = this.captureStableSelection(this.workOrderInfo)
                        this.originalRelationSelection = this.captureRelationSelection(this.workOrderInfo)
                        this.resolvedRelationSomeID = String(this.workOrderInfo.someID || '').trim()
                    }
                    this.syncProductSelection()
                    this.ensureCurrentIssueOption()
                    this.syncClassificationOptions()
                }).catch(() => {
                    if(this.componentDestroyed || requestSeq !== this.workOrderRequestSeq) return
                    this.loading = false
                })
            },
            initUserList() {
                this.$apiGet('lechun-baseservice/user/getUserListForDorpbox',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.userList = res || []

                })
            },
            initDeptList() {
                this.$apiGet('lechun-csms/workOrder/getWorkOrderResponseDept',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.deptList = res

                })
            },
            initIssueOptions() {
                const requestSeq = ++this.issueRequestSeq
                return this.$apiGet('lechun-csms/workOrder/classification/issues',{}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.issueRequestSeq) return
                    this.issueOptions = res || []
                    this.ensureCurrentIssueOption()
                    this.syncClassificationOptions()
                })
            },
            initLegacyTypeList() {
                this.$apiGet('lechun-csms/workOrder/workOrderTypeList',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.legacyTypeOptions = res || []
                })
            },
            initWorkOrderResultList() {
                this.$apiGet('lechun-csms/workOrder/getWorkOrderResultList',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.workResultList = res
                })
            },
            initOrderSourceList() {
                this.$apiGet('lechun-csms/workOrder/getWorkOrderSourceList',{}).then(res => {
                    if(this.componentDestroyed) return
                    this.orderSourceList = res
                })
            },
            getOrder() {
                const someID = (this.workOrderInfo.someID || '').trim()
                if(!someID){
                    this.$message.warning('请先输入外部单号')
                    return
                }
                this.$set(this.workOrderInfo,'someID',someID)
                this.initList('getOrder')
            },
            toBuyer(id) {
                this.$router.push({name: 'userDetail', params: {id: id}})
            },
            findWorkTypeNode(nodes,value){
                for(let i = 0; i < (nodes || []).length; i++){
                    const item = nodes[i]
                    if(String(item.value) === String(value)) return item
                    const child = this.findWorkTypeNode(item.children,value)
                    if(child) return child
                }
                return null
            },
            captureStableSelection(info){
                if(!info || !info.issueCode) return null
                return {
                    issueCode:info.issueCode,
                    temperatureZone:info.temperatureZone,
                    productLineCode:info.productLineCode,
                    factoryCode:info.factoryCode,
                    shopCode:info.shopCode,
                }
            },
            captureRelationSelection(info){
                if(!info) return null
                return {
                    someID:String(info.someID || '').trim(),
                    relateType:Number(info.relateType || 0),
                }
            },
            shouldPreserveRelationSnapshot(relatedInfo){
                if(this.isNewWorkOrder() || !this.originalRelationSelection
                    || !this.originalRelationSelection.someID){
                    return false
                }
                const source = relatedInfo || {}
                const requestedSomeID = String(source.someID || this.workOrderInfo.someID || '').trim()
                return Number(source.relateType || 0) === 0
                    && requestedSomeID === this.originalRelationSelection.someID
            },
            isOriginalStableSelection(fields){
                const original = this.originalStableSelection
                if(!original) return false
                return Object.keys(fields).every(key =>
                    String(original[key] || '') === String(fields[key] || ''))
            },
            shouldPreserveCurrentAssignee(fields){
                return Boolean(this.workOrderInfo.handleUserId)
                    && this.isOriginalStableSelection(fields)
            },
            ensureCurrentIssueOption(){
                const issueCode = this.workOrderInfo.issueCode
                if(!issueCode || this.findWorkTypeNode(this.issueOptions,issueCode)) return
                const groupName = this.workOrderInfo.workOrderTypeGroup || '历史售后问题'
                const groupCode = {物流:'LOGISTICS',质量:'QUALITY',运营:'OPERATION'}[groupName] || 'HISTORY'
                const options = (this.issueOptions || []).map(item => ({
                    ...item,
                    children:[...(item.children || [])],
                }))
                let group = options.find(item => item.value === groupCode)
                if(!group){
                    group = {value:groupCode,label:groupName,children:[]}
                    options.push(group)
                }
                group.children.push({
                    value:issueCode,
                    label:`${this.workOrderInfo.workOrderTypeName || issueCode}（已停用）`,
                    issueCode,
                    issueGroupCode:groupCode,
                    issueGroupName:groupName,
                    responsibleUserId:this.workOrderInfo.handleUserId,
                    responsibleDeptDingdingId:this.workOrderInfo.responsibleDeptDingdingId,
                    disabled:true,
                })
                this.issueOptions = options
            },
            handleIssueChange(issueCode,targetProductLineCode,targetFactoryCode){
                this.productLineRequestSeq += 1
                this.factoryRequestSeq += 1
                this.shopRouteRequestSeq += 1
                const issue = this.findWorkTypeNode(this.issueOptions,issueCode)
                this.$set(this.workOrderInfo,'workOrderTypeCode',null)
                this.$set(this.workOrderInfo,'workOrderTypeGroup',issue ? issue.issueGroupName : '')
                this.$set(this.workOrderInfo,'workOrderTypeName',issue ? issue.label : '')
                this.$set(this.workOrderInfo,'productLineCode','')
                this.$set(this.workOrderInfo,'factoryCode','')
                this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                this.$set(this.workOrderInfo,'workOrderTypeFactory','')
                this.productLineOptions = []
                this.factoryOptions = []
                this.clearClassificationRoute()
                if(!issue){
                    return Promise.resolve()
                }
                if(issue.issueGroupCode === 'QUALITY'){
                    return this.loadProductLines(false,targetProductLineCode,targetFactoryCode)
                }else if(issue.issueGroupCode === 'OPERATION'){
                    return this.loadShopRoute()
                }else{
                    this.applyRouteUser(issue)
                    return Promise.resolve()
                }
            },
            handleTemperatureZoneChange(){
                if(!this.useStableClassification || !this.isQualityIssue) return Promise.resolve()
                this.productLineRequestSeq += 1
                this.$set(this.workOrderInfo,'productLineCode','')
                this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                this.productLineOptions = []
                return this.loadProductLines(false)
            },
            clearQualityRouteSelection(){
                this.productLineRequestSeq += 1
                this.factoryRequestSeq += 1
                this.$set(this.workOrderInfo,'productLineCode','')
                this.$set(this.workOrderInfo,'factoryCode','')
                this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                this.$set(this.workOrderInfo,'workOrderTypeFactory','')
                this.productLineOptions = []
                this.factoryOptions = []
                if(this.isQualityIssue){
                    this.clearClassificationRoute()
                }
            },
            handleProductLineChange(){
                const selected = this.productLineOptions.find(item => item.productLineCode === this.workOrderInfo.productLineCode)
                if(selected) this.$set(this.workOrderInfo,'workOrderTypeMatClass',selected.productLineName || '')
                return Promise.resolve()
            },
            handleFactoryChange(factoryCode){
                const routes = this.factoryOptions.filter(item => item.factoryCode === factoryCode)
                const route = routes[0]
                if(route){
                    this.$set(this.workOrderInfo,'workOrderTypeFactory',route.factoryName || '')
                    if(routes.length === 1) this.applyRouteUser(route)
                    else this.clearClassificationRoute()
                }else{
                    this.clearClassificationRoute()
                }
            },
            syncClassificationOptions(){
                if(!this.useStableClassification) return
                const issue = this.selectedIssue
                if(this.isQualityIssue){
                    this.loadProductLines(true)
                }else if(this.isOperationIssue){
                    this.loadShopRoute()
                }else if(issue && !this.shouldPreserveCurrentAssignee({
                    issueCode:this.workOrderInfo.issueCode,
                })){
                    this.applyRouteUser(issue)
                }
            },
            loadProductLines(preserveSelection,targetProductLineCode,targetFactoryCode){
                const requestSeq = ++this.productLineRequestSeq
                this.factoryRequestSeq += 1
                if(!this.isQualityIssue || !this.isSupportedTemperatureZone){
                    this.productLineOptions = []
                    this.factoryOptions = []
                    this.$set(this.workOrderInfo,'productLineCode','')
                    this.$set(this.workOrderInfo,'factoryCode','')
                    this.$set(this.workOrderInfo,'workOrderTypeMatClass','')
                    this.$set(this.workOrderInfo,'workOrderTypeFactory','')
                    this.clearClassificationRoute()
                    return Promise.resolve()
                }
                const temperatureZone = this.workOrderInfo.temperatureZone
                return this.$apiGet('lechun-csms/workOrder/classification/productLines',{temperatureZone}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.productLineRequestSeq
                        || temperatureZone !== this.workOrderInfo.temperatureZone || !this.isQualityIssue) return
                    this.productLineOptions = res || []
                    const desiredProductLineCode = targetProductLineCode || this.workOrderInfo.productLineCode
                    let selectedExists = this.productLineOptions.some(item =>
                        item.productLineCode === desiredProductLineCode)
                    if(!selectedExists && preserveSelection && desiredProductLineCode
                        && this.isOriginalStableSelection({
                            issueCode:this.workOrderInfo.issueCode,
                            temperatureZone,
                            productLineCode:desiredProductLineCode,
                        })){
                        this.productLineOptions.push({
                            productLineCode:desiredProductLineCode,
                            productLineName:`${this.workOrderInfo.workOrderTypeMatClass || desiredProductLineCode}（已停用）`,
                            disabled:true,
                        })
                        selectedExists = true
                    }
                    if(!selectedExists){
                        this.$set(this.workOrderInfo,'productLineCode','')
                        return this.loadFactories(Boolean(preserveSelection),targetFactoryCode)
                    }
                    this.$set(this.workOrderInfo,'productLineCode',desiredProductLineCode)
                    const selectedProductLine = this.productLineOptions.find(item =>
                        item.productLineCode === desiredProductLineCode)
                    if(selectedProductLine){
                        this.$set(this.workOrderInfo,'workOrderTypeMatClass',selectedProductLine.productLineName || '')
                    }
                    return this.loadFactories(Boolean(preserveSelection),targetFactoryCode)
                })
            },
            loadFactories(preserveSelection,targetFactoryCode){
                const requestSeq = ++this.factoryRequestSeq
                const temperatureZone = this.workOrderInfo.temperatureZone
                if(!this.isQualityIssue){
                    this.factoryOptions = []
                    return Promise.resolve()
                }
                return this.$apiGet('lechun-csms/workOrder/classification/factoryRoutes',{}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.factoryRequestSeq
                        || temperatureZone !== this.workOrderInfo.temperatureZone
                        || !this.isQualityIssue) return
                    this.factoryOptions = res || []
                    const desiredFactoryCode = targetFactoryCode || this.workOrderInfo.factoryCode
                    let selectedExists = this.factoryOptions.some(item =>
                        item.factoryCode === desiredFactoryCode)
                    if(!selectedExists && preserveSelection && desiredFactoryCode
                        && this.isOriginalStableSelection({
                            issueCode:this.workOrderInfo.issueCode,
                            temperatureZone,
                            factoryCode:desiredFactoryCode,
                        })){
                        this.factoryOptions.push({
                            temperatureZone,
                            productLineName:this.workOrderInfo.workOrderTypeMatClass || '',
                            factoryCode:desiredFactoryCode,
                            factoryName:`${this.workOrderInfo.workOrderTypeFactory || desiredFactoryCode}（已停用）`,
                            responsibleUserId:this.workOrderInfo.handleUserId,
                            responsibleDeptDingdingId:this.workOrderInfo.responsibleDeptDingdingId,
                            disabled:true,
                        })
                        selectedExists = true
                    }
                    if(selectedExists && (preserveSelection || targetFactoryCode)){
                        this.$set(this.workOrderInfo,'factoryCode',desiredFactoryCode)
                        const route = this.factoryOptions.find(item =>
                            item.factoryCode === desiredFactoryCode)
                        const preserveAssignee = this.shouldPreserveCurrentAssignee({
                            issueCode:this.workOrderInfo.issueCode,
                            temperatureZone,
                            factoryCode:desiredFactoryCode,
                        })
                        if(preserveAssignee){
                            if(route && !this.workOrderInfo.workOrderTypeMatClass){
                                this.$set(this.workOrderInfo,'workOrderTypeMatClass',route.productLineName || '')
                            }
                            if(route && !this.workOrderInfo.workOrderTypeFactory){
                                this.$set(this.workOrderInfo,'workOrderTypeFactory',route.factoryName || '')
                            }
                        }else{
                            this.handleFactoryChange(desiredFactoryCode)
                        }
                    }else if(this.factorySelectOptions.length === 1){
                        this.$set(this.workOrderInfo,'factoryCode',this.factorySelectOptions[0].factoryCode)
                        this.handleFactoryChange(this.factorySelectOptions[0].factoryCode)
                    }else{
                        this.$set(this.workOrderInfo,'factoryCode','')
                        this.clearClassificationRoute()
                    }
                })
            },
            loadShopRoute(){
                const requestSeq = ++this.shopRouteRequestSeq
                const shopCode = this.workOrderInfo.shopCode
                if(!this.isOperationIssue || !shopCode){
                    this.clearClassificationRoute()
                    return Promise.resolve()
                }
                const preserveAssignee = this.shouldPreserveCurrentAssignee({
                    issueCode:this.workOrderInfo.issueCode,
                    shopCode,
                })
                if(!preserveAssignee){
                    this.clearClassificationRoute()
                }
                return this.$apiGet('lechun-csms/workOrder/classification/shopRoute',{shopCode}).then(res => {
                    if(this.componentDestroyed || requestSeq !== this.shopRouteRequestSeq
                        || shopCode !== this.workOrderInfo.shopCode || !this.isOperationIssue) return
                    if(res && !preserveAssignee){
                        this.applyRouteUser(res)
                    }else if(this.isOriginalStableSelection({
                        issueCode:this.workOrderInfo.issueCode,
                        shopCode,
                    })){
                        // 已有工单允许保留后来停用的原店铺路由；新建或改店铺仍必须命中启用路由。
                        return
                    }else{
                        this.clearClassificationRoute()
                    }
                }).catch(() => {
                    if(this.componentDestroyed || requestSeq !== this.shopRouteRequestSeq
                        || shopCode !== this.workOrderInfo.shopCode || !this.isOperationIssue) return
                    if(!preserveAssignee){
                        this.clearClassificationRoute()
                    }
                })
            },
            applyRouteUser(route){
                const handleUserId = route.responsibleUserId || ''
                const deptId = route.responsibleDeptDingdingId || ''
                this.$set(this.workOrderInfo,'handleUserId',handleUserId)
                this.$set(this.workOrderInfo,'handleUserName',handleUserId ? this.userNameById(handleUserId) : '')
                this.$set(this.workOrderInfo,'responsibleDeptDingdingId',deptId)
                const dept = (this.deptList || []).find(item => String(item.key) === String(deptId))
                this.$set(this.workOrderInfo,'responsibleDeptName',dept ? dept.name : '')
            },
            clearClassificationRoute(){
                this.$set(this.workOrderInfo,'handleUserId','')
                this.$set(this.workOrderInfo,'handleUserName','')
                this.$set(this.workOrderInfo,'responsibleDeptDingdingId','')
                this.$set(this.workOrderInfo,'responsibleDeptName','')
            },
            handleWorkTypeChange(val,type){
                if(type=='workType'){
                    const data = this.findWorkTypeNode(this.legacyTypeOptions,val)
                    this.$set(this.workOrderInfo,'handleUserId',data && data.respUserId ? data.respUserId : '')
                    this.$set(this.workOrderInfo,'handleUserName',this.userNameById(this.workOrderInfo.handleUserId))
                    this.$set(this.workOrderInfo,'workOrderTypeName',data ? data.label : '')
                }else{
                    this.$set(this.workOrderInfo,type,val)
                }
            },
            validateWorkOrder(){
                if(String(this.workOrderNo) !== '0'){
                    if(!(this.workOrderInfo.workOrderDesc || '').trim()) return '请填写售后问题描述'
                    if(this.workOrderInfo.communicationStatus === 'PENDING_REPLY' && !(this.workOrderInfo.productionQuestion || '').trim()) return '选择“待生产回复”时，请填写待生产回复问题'
                    if(this.workOrderInfo.communicationStatus === 'RESULT_AVAILABLE' && !(this.workOrderInfo.communicationResult || '').trim()) return '选择“已有沟通结果”时，请填写沟通结果'
                    if(this.workOrderInfo.communicationStatus === 'REPLIED' && !this.workOrderInfo.productionReply) return '尚无生产回复，不能选择“生产已回复”'
                    return ''
                }
                if(!this.workOrderInfo.orderOnline) return '请选择购买渠道'
                if(this.useStableClassification){
                    if(!this.workOrderInfo.issueCode) return '请选择售后问题'
                    if(this.isQualityIssue){
                        if(!this.isSupportedTemperatureZone) return '请确认商品温层'
                        if(!this.workOrderInfo.productLineCode) return '请选择产品线'
                        if(!this.workOrderInfo.factoryCode) return '请选择工厂'
                    }
                    if(this.isOperationIssue && !this.workOrderInfo.shopCode){
                        return '当前订单缺少店铺编码，请先获取订单明细'
                    }
                    if(!this.workOrderInfo.handleUserId) return '当前条件未配置处理人，请先完善路由配置'
                }else{
                    if(!this.workOrderInfo.workOrderTypeCode) return '请选择历史售后类型'
                    if(!this.workOrderInfo.handleUserId) return '该类型未配置负责人，请人工选择处理人'
                }
                if(!(this.workOrderInfo.workOrderDesc || '').trim()) return '请填写售后问题描述'
                if(this.workOrderInfo.communicationStatus === 'PENDING_REPLY'
                    && !(this.workOrderInfo.productionQuestion || '').trim()){
                    return '选择“待生产回复”时，请填写待生产回复问题'
                }
                if(this.workOrderInfo.communicationStatus === 'RESULT_AVAILABLE'
                    && !(this.workOrderInfo.communicationResult || '').trim()){
                    return '选择“已有沟通结果”时，请填写沟通结果'
                }
                if(this.workOrderInfo.communicationStatus === 'REPLIED'
                    && !this.workOrderInfo.productionReply){
                    return '尚无生产回复，不能选择“生产已回复”'
                }
                if(this.uploadingCount > 0) return '图片仍在上传，请稍后再提交'
                return ''
            },
            addWorkOrderSubmit(){
                if(this.saving) return
                const error = this.validateWorkOrder()
                if(error){
                    this.$message.warning(error)
                    return
                }
                if(this.missingPictureWarning){
                    this.$confirm(
                        `${this.missingPictureWarning}。若当前确实无法提供，可以确认后继续提交。`,
                        '图片信息不完整',
                        {confirmButtonText:'确认提交',cancelButtonText:'继续补图',type:'warning'}
                    ).then(() => {
                        if(!this.componentDestroyed) this.saveWorkOrder(true)
                    }).catch(() => {})
                    return
                }
                this.saveWorkOrder(false)
            },
            handleAiPaste(event){
                const clipboardData = event.clipboardData || window.clipboardData
                if(!clipboardData || !clipboardData.items) return
                const files = []
                for(let i = 0; i < clipboardData.items.length; i++){
                    const item = clipboardData.items[i]
                    if(item.kind === 'file' && item.type && item.type.indexOf('image/') === 0){
                        const file = item.getAsFile()
                        if(file) files.push(file)
                    }
                }
                if(!files.length) return
                const pastedText = clipboardData.getData ? clipboardData.getData('text/plain') : ''
                if(!pastedText) event.preventDefault()
                files.forEach(file => this.uploadAiImage({file}))
            },
            uploadAiImage(upload){
                const file = upload && upload.file
                if(!file || !file.type || file.type.indexOf('image/') !== 0){
                    this.$message.warning('只能上传图片文件')
                    return Promise.resolve()
                }
                if(this.aiImages.length + this.aiUploadingCount >= 10){
                    this.$message.warning('AI识别最多上传10张图片')
                    return Promise.resolve()
                }
                const fileForm = new FormData()
                fileForm.append('file',file)
                this.aiUploadingCount += 1
                return this.$apiUpload('lechun-cms/file/uploadFile',fileForm).then(res => {
                    if(this.componentDestroyed) return
                    if(!res || Number(res.status) !== 200){
                        this.$message.error((res && res.message) || '图片上传失败，请稍后重试')
                        return
                    }
                    const url = res.value && res.value[0]
                    if(!url){
                        this.$message.error('图片上传成功，但未返回图片地址')
                        return
                    }
                    if(this.aiImages.some(item => item.url === url)) return
                    this.aiImages.push({url,name:file.name || '粘贴图片'})
                    this.aiResultVisible = false
                }).catch(() => {
                    // 网络异常由统一请求层提示。
                }).finally(() => {
                    this.aiUploadingCount = Math.max(0,this.aiUploadingCount - 1)
                })
            },
            removeAiImage(index){
                this.aiImages.splice(index,1)
                this.aiResultVisible = false
            },
            recognizeAiDraft(){
                const text = (this.aiInputText || '').trim()
                if(!text && !this.aiImages.length){
                    this.$message.warning('请填写文字或上传图片后再识别')
                    return
                }
                if(this.aiUploadingCount > 0){
                    this.$message.warning('图片仍在上传，请稍后再识别')
                    return
                }
                if(this.aiRecognizing) return
                this.aiRecognizing = true
                this.aiWarnings = []
                this.aiUnresolvedFields = []
                this.aiResultVisible = false
                this.$apiPost('lechun-csms/workOrder/aiParseDraft',{
                    text,
                    images:this.aiImages.map(item => ({url:item.url})),
                    currentDraft:this.buildSafeDraft(),
                }).then(result => this.applyAiDraft(result || {})).catch(() => {
                    // 接口异常由统一请求层提示，保留当前人工草稿。
                }).finally(() => {
                    if(!this.componentDestroyed) this.aiRecognizing = false
                })
            },
            hasOwnField(object,key){
                return Object.prototype.hasOwnProperty.call(object || {},key)
            },
            async applyAiDraft(result){
                if(this.componentDestroyed) return
                const draft = result.draft || {}
                const relatedData = result.relatedData || {}
                this.aiWarnings = [...(result.warnings || [])]
                this.aiUnresolvedFields = [...(result.unresolvedFields || [])]

                const authoritativeOrder = Number(draft.relateType || 0) > 0
                const orderFields = [
                    'someID','relateType','orderNo','refundNo','customerId','orderOnline','orderSource',
                    'onlineShopName','offlineShopName','offlineOrderNo','contactName','contactPhone',
                    'contactAddr','temperatureZone','shopCode','workOrderProductList',
                ]
                if(authoritativeOrder){
                    orderFields.forEach(key => {
                        if(!this.hasOwnField(draft,key)) return
                        const value = key === 'workOrderProductList'
                            ? (draft[key] || []).map(item => ({...item,picList:item.picList || []}))
                            : draft[key]
                        this.$set(this.workOrderInfo,key,value)
                    })
                    this.orderDetailInfo = relatedData.orderDetail || {}
                    this.routers = this.normalizeRouters(relatedData.wayNos)
                    this.resolvedRelationSomeID = String(draft.someID || '').trim()
                    this.syncProductSelection()
                }else if(!this.workOrderInfo.someID && draft.someID){
                    this.$set(this.workOrderInfo,'someID',draft.someID)
                }

                const hasManualCommunication = Boolean(
                    (this.workOrderInfo.communicationResult || '').trim()
                    || (this.workOrderInfo.productionQuestion || '').trim()
                    || this.workOrderInfo.communicationStatus !== 'NO_REPLY_REQUIRED'
                )
                ;['workOrderDesc','communicationResult','productionQuestion'].forEach(key => {
                    if(!(this.workOrderInfo[key] || '').trim() && (draft[key] || '').trim()){
                        this.$set(this.workOrderInfo,key,draft[key])
                    }
                })
                if(!hasManualCommunication && draft.communicationStatus){
                    this.$set(this.workOrderInfo,'communicationStatus',draft.communicationStatus)
                }
                if(!authoritativeOrder && this.workOrderInfo.temperatureZone === 'UNKNOWN'
                    && ['COLD','AMBIENT'].indexOf(draft.temperatureZone) > -1){
                    this.$set(this.workOrderInfo,'temperatureZone',draft.temperatureZone)
                }

                await this.initIssueOptions()
                if(this.componentDestroyed) return
                const currentIssueCode = this.workOrderInfo.issueCode
                const targetIssueCode = draft.issueCode || ''
                if(!currentIssueCode && targetIssueCode){
                    this.$set(this.workOrderInfo,'issueCode',targetIssueCode)
                    await this.handleIssueChange(
                        targetIssueCode,
                        draft.productLineCode || '',
                        draft.factoryCode || ''
                    )
                }else if(currentIssueCode && targetIssueCode
                    && String(currentIssueCode) === String(targetIssueCode)){
                    if(this.isQualityIssue){
                        await this.loadProductLines(
                            Boolean(this.workOrderInfo.productLineCode),
                            this.workOrderInfo.productLineCode || draft.productLineCode || '',
                            this.workOrderInfo.factoryCode || draft.factoryCode || ''
                        )
                    }else if(this.isOperationIssue){
                        await this.loadShopRoute()
                    }else if(this.selectedIssue){
                        this.applyRouteUser(this.selectedIssue)
                    }
                }else if(currentIssueCode && targetIssueCode
                    && String(currentIssueCode) !== String(targetIssueCode)){
                    this.aiWarnings.push('当前已选择售后问题，AI识别结果未覆盖，请人工核对')
                }

                const acceptedCategories = this.pictureCategoryOptions.map(item => item.value)
                const pictures = [...(this.workOrderInfo.workOrderPics || [])]
                const pictureUrls = new Set(pictures.map(item => item.picUrl))
                ;(draft.workOrderPics || []).forEach(item => {
                    if(!item || !item.picUrl || pictureUrls.has(item.picUrl)) return
                    pictures.push({
                        ...item,
                        picCategory:acceptedCategories.indexOf(item.picCategory) > -1
                            ? item.picCategory : 'OTHER',
                    })
                    pictureUrls.add(item.picUrl)
                })
                pictures.forEach((item,index) => { item.picIndex = index + 1 })
                this.$set(this.workOrderInfo,'workOrderPics',pictures)

                this.aiWarnings = [...new Set(this.aiWarnings.filter(Boolean))]
                this.aiUnresolvedFields = [...new Set(this.aiUnresolvedFields.filter(Boolean))]
                this.aiResultVisible = true
                this.$message.success('AI识别结果已回填，请核对后再保存')
            },
            createRequestToken(prefix){
                return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`
            },
            isNewWorkOrder(){
                return String(this.workOrderNo) === '0'
            },
            buildSafeDraft(){
                const source = this.workOrderInfo || {}
                return {
                    someID:source.someID || '',
                    relateType:source.relateType,
                    orderOnline:source.orderOnline,
                    orderSource:source.orderSource || '',
                    onlineShopName:source.onlineShopName || '',
                    offlineShopName:source.offlineShopName || '',
                    offlineOrderNo:source.offlineOrderNo || '',
                    issueCode:source.issueCode || '',
                    productLineCode:source.productLineCode || '',
                    factoryCode:source.factoryCode || '',
                    shopCode:source.shopCode || '',
                    workOrderTypeCode:source.workOrderTypeCode || null,
                    workOrderTypeGroup:source.workOrderTypeGroup || '',
                    workOrderTypeName:source.workOrderTypeName || '',
                    workOrderTypeMatClass:source.workOrderTypeMatClass || '',
                    workOrderTypeFactory:source.workOrderTypeFactory || '',
                    handleUserId:source.handleUserId || '',
                    responsibleDeptDingdingId:source.responsibleDeptDingdingId || '',
                    temperatureZone:source.temperatureZone || 'UNKNOWN',
                    workOrderDesc:source.workOrderDesc || '',
                    communicationStatus:source.communicationStatus || 'NO_REPLY_REQUIRED',
                    communicationResult:source.communicationResult || '',
                    productionQuestion:source.productionQuestion || '',
                }
            },
            hasDraftContent(draft){
                return Boolean(
                    draft.someID || draft.orderSource || draft.offlineShopName || draft.offlineOrderNo
                    || draft.issueCode || draft.productLineCode || draft.factoryCode || draft.shopCode
                    || draft.workOrderTypeCode || draft.handleUserId || draft.responsibleDeptDingdingId
                    || draft.workOrderDesc || draft.communicationResult || draft.productionQuestion
                    || draft.temperatureZone !== 'UNKNOWN'
                    || draft.communicationStatus !== 'NO_REPLY_REQUIRED'
                )
            },
            scheduleDraftSave(){
                if(this.componentDestroyed || !this.isNewWorkOrder() || !this.draftReady) return
                if(this.draftSaveTimer){
                    clearTimeout(this.draftSaveTimer)
                }
                this.draftSaveTimer = setTimeout(() => this.persistDraft(),500)
            },
            persistDraft(){
                this.draftSaveTimer = null
                if(this.componentDestroyed) return
                const draft = this.buildSafeDraft()
                try{
                    if(!this.hasDraftContent(draft)){
                        sessionStorage.removeItem(this.draftStorageKey)
                        return
                    }
                    sessionStorage.setItem(this.draftStorageKey,JSON.stringify({
                        expiresAt:Date.now() + this.draftTtlMs,
                        resolvedRelationSomeID:this.resolvedRelationSomeID,
                        data:draft,
                    }))
                }catch(e){
                    // 草稿是辅助能力，存储不可用时不阻断工单填写
                }
            },
            restoreDraft(){
                try{
                    const raw = sessionStorage.getItem(this.draftStorageKey)
                    if(!raw){
                        this.draftReady = true
                        return
                    }
                    const stored = JSON.parse(raw)
                    if(!stored || !stored.data || !stored.expiresAt || stored.expiresAt <= Date.now()){
                        sessionStorage.removeItem(this.draftStorageKey)
                        this.draftReady = true
                        return
                    }
                    this.workOrderInfo = this.normalizeWorkOrderInfo({
                        ...this.workOrderInfo,
                        ...stored.data,
                    })
                    this.resolvedRelationSomeID = String(stored.resolvedRelationSomeID || '').trim()
                    this.$message.info('已恢复当前会话中未提交的工单草稿')
                }catch(e){
                    sessionStorage.removeItem(this.draftStorageKey)
                }finally{
                    this.draftReady = true
                }
            },
            clearDraft(){
                if(this.draftSaveTimer){
                    clearTimeout(this.draftSaveTimer)
                    this.draftSaveTimer = null
                }
                try{
                    sessionStorage.removeItem(this.draftStorageKey)
                }catch(e){
                    // sessionStorage 不可用时无需影响主流程
                }
            },
            saveWorkOrder(confirmIncompletePictures){
                if(this.saving) return
                if(String(this.workOrderNo) !== '0'){
                    const param = {
                        workOrderNo:this.workOrderInfo.workOrderNo,
                        contactName:this.workOrderInfo.contactName,
                        contactPhone:this.workOrderInfo.contactPhone,
                        contactAddr:this.workOrderInfo.contactAddr,
                        orderSource:this.workOrderInfo.orderSource,
                        offlineShopName:this.workOrderInfo.offlineShopName,
                        offlineOrderNo:this.workOrderInfo.offlineOrderNo,
                        workOrderDesc:this.workOrderInfo.workOrderDesc,
                        communicationStatus:this.workOrderInfo.communicationStatus,
                        communicationResult:this.workOrderInfo.communicationResult,
                        productionQuestion:this.workOrderInfo.productionQuestion
                    }
                    this.saving = true
                    this.$apiPost('lechun-csms/workOrder/simpleUpdateWorkOrder',param).then(() => {
                        if(this.componentDestroyed) return
                        this.saving = false
                        this.$message({message:'工单信息已更新',type:'success',onClose:()=>this.$router.history.go(-1)})
                    }).catch(() => { if(!this.componentDestroyed) this.saving = false })
                    return
                }
                if(!this.saveRequestToken){
                    this.saveRequestToken = this.createRequestToken('work-order-save')
                }
                const selectedProducts = this.multipleSelProList
                const param = {
                    ...this.workOrderInfo,
                    workOrderTypeCode:this.useStableClassification
                        ? null : (this.workOrderInfo.workOrderTypeCode || null),
                    issueCode:this.useStableClassification ? this.workOrderInfo.issueCode : null,
                    productLineCode:this.useStableClassification ? this.workOrderInfo.productLineCode : null,
                    factoryCode:this.useStableClassification ? this.workOrderInfo.factoryCode : null,
                    shopCode:this.useStableClassification ? this.workOrderInfo.shopCode : null,
                    requestToken:this.saveRequestToken,
                    confirmIncompletePictures,
                    workOrderPics:(this.workOrderInfo.workOrderPics || []).map((item,index) => ({
                        picUrl:item.picUrl,
                        picCategory:item.picCategory,
                        picIndex:index + 1,
                    })),
                    workOrderProductList:(this.workOrderInfo.workOrderProductList || []).map(item => ({
                        ...item,
                        isChosen:selectedProducts.indexOf(item) > -1 ? 1 : 0,
                    })),
                }
                this.saving = true
                this.$apiPost('lechun-csms/workOrder/saveWorkOrder',param).then(() => {
                    if(this.componentDestroyed) return
                    this.saving = false
                    this.saveRequestToken = ''
                    this.clearDraft()
                    this.$message({
                        message: '成功',
                        type: 'success',
                        onClose: () => {
                            this.$router.history.go(-1)
                            // this.$router.push({name: 'workOrderList'})
                        }
                    })
                }).catch(() => {
                    if(this.componentDestroyed) return
                    this.saving = false
                })
            },
            handleClose(){
                this.addWorkOrderVisible = false;
                this.formData = {}
            },
            handleWorkOrder(from) {
                this.handleTitle = this.handleList[from].title
                this.handleWorkType = from
                if(from==0){
                    this.initWorkOrderResultList()
                    this.initDeptList()
                }
                this.addWorkOrderVisible = true;
            },
            returnPage() {
                window.history.go(-1)
                // this.$router.push({
                //     name: 'workOrderList'
                // })
            },
            uploadFile(file,type) {
                const pictureCategory = this.newPictureCategory
                const fileForm = new FormData()
                fileForm.append('file',file.file)
                this.uploadingCount += 1
                this.$apiUpload('lechun-cms/file/uploadFile',fileForm).then(res => {
                    if(this.componentDestroyed) return
                    if(!res || Number(res.status) !== 200){
                        this.$message.error((res && res.message) || '图片上传失败，请稍后重试')
                        return
                    }
                    const picUrl = res && res.value && res.value[0]
                    if(!picUrl){
                        this.$message.error('图片上传成功，但未返回图片地址')
                        return
                    }
                    if(type=='order'){
                        const pictures = this.workOrderInfo.workOrderPics || []
                        pictures.push({
                            picUrl,
                            picCategory:pictureCategory,
                            picIndex:pictures.length + 1,
                        })
                        this.$set(this.workOrderInfo,'workOrderPics',pictures)
                    }else{
                        const picList = type.picList || []
                        picList.push(picUrl)
                        this.$set(type,'picList',picList)
                    }
                }).catch(() => {
                    // 网络异常由统一请求层提示。
                }).finally(() => {
                    this.uploadingCount = Math.max(0,this.uploadingCount - 1)
                })
            },
            removeWorkOrderPic(index){
                const pictures = [...(this.workOrderInfo.workOrderPics || [])]
                pictures.splice(index,1)
                pictures.forEach((item,itemIndex) => { item.picIndex = itemIndex + 1 })
                this.$set(this.workOrderInfo,'workOrderPics',pictures)
            },
            removeProductPic(product,index){
                const pictures = [...(product.picList || [])]
                pictures.splice(index,1)
                this.$set(product,'picList',pictures)
            },
            submitProductionReply(){
                const reply = (this.productionReplyInput || '').trim()
                if(!reply){
                    this.$message.warning('请填写生产回复')
                    return
                }
                if(this.productionReplySaving) return
                if(!this.replyRequestToken){
                    this.replyRequestToken = this.createRequestToken('production-reply')
                }
                this.productionReplySaving = true
                this.$apiPost('lechun-csms/workOrder/productionReply',{
                    workOrderNo:this.workOrderInfo.workOrderNo || this.workOrderNo,
                    productionReply:reply,
                    requestToken:this.replyRequestToken,
                }).then(() => {
                    if(this.componentDestroyed) return
                    this.productionReplySaving = false
                    this.replyRequestToken = ''
                    this.productionReplyInput = ''
                    this.$message.success('生产回复已提交，并将通知工单发起人')
                    this.initList()
                }).catch(() => {
                    if(this.componentDestroyed) return
                    this.productionReplySaving = false
                })
            },
            handleWorkOrderSubmit(){
                let param = {...this.formData}
                param.workOrderNo = this.workOrderNo
                let url = this.handleList[this.handleWorkType].apiUrl
                this.$apiGet(url,param).then(() => {
                    if(this.componentDestroyed) return
                    this.$message({
                        message: '成功',
                        type: 'success'
                    });
                    this.handleClose()
                    this.initList()
                })
            },
            handleSelectionChange(val){
                this.multipleSelProList = val
            },
            pasteImgFun(event,proItem){
                const clipboardData = event.clipboardData || window.clipboardData;

                if (clipboardData) {
                    let hasImage = false
                    for (let i = 0; i < clipboardData.items.length; i++) {
                        const item = clipboardData.items[i];
                        if (item.kind === 'file' && item.type.startsWith('image/')) {
                            const file = item.getAsFile();
                            hasImage = true
                            this.uploadFile({file:file},proItem?proItem:'order')
                        }
                    }
                    if(hasImage) event.preventDefault()
                    else this.$message.warning('剪贴板中没有可上传的图片')
                }
            }
        }
    }
</script>


<style lang="scss">
.work-order-detail-info {

    .ai-draft-card{
        margin-bottom: 16px;
        border-color: #b3d8ff;
        background: #f7fbff;
    }
    .ai-draft-card .el-card__header{
        padding: 12px 16px;
        border-bottom-color: #d9ecff;
    }
    .ai-draft-card .el-card__body{
        padding: 16px;
    }
    .ai-draft-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    }
    .ai-draft-title{
        color: #1677ff;
        font-size: 16px;
        font-weight: 600;
    }
    .ai-draft-subtitle{
        margin-left: 12px;
        color: #606266;
        font-size: 12px;
    }
    .ai-draft-actions{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 12px;
    }
    .ai-paste-zone{
        min-width: 132px;
        height: 32px;
        padding: 0 12px;
        border: 1px dashed #409eff;
        border-radius: 4px;
        color: #409eff;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        outline: none;
        background: #fff;
    }
    .ai-paste-zone:focus{
        border-style: solid;
        background: #ecf5ff;
    }
    .ai-draft-tip{
        color: #909399;
        font-size: 12px;
    }
    .ai-image-list{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 12px;
    }
    .ai-image-item{
        position: relative;
    }
    .ai-image{
        width: 80px;
        height: 80px;
        border-radius: 4px;
    }
    .ai-image-delete{
        position: absolute;
        top: -8px;
        right: -8px;
        padding: 5px;
    }
    .ai-result-alert{
        margin-top: 12px;
    }
    .ai-feedback-list{
        margin-top: 10px;
        padding: 8px 12px;
        border-radius: 4px;
        color: #e6a23c;
        font-size: 12px;
        line-height: 22px;
        background: #fdf6ec;
    }
    .ai-feedback-title{
        font-weight: 600;
    }
    .ai-warning-item{
        word-break: break-word;
    }
    .ai-unresolved-fields{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        margin-top: 10px;
        color: #606266;
        font-size: 12px;
    }
    .ai-unresolved-fields .el-tag{
        margin-right: 0;
    }

    .box-card{
        margin-bottom: 20px;
    }
    .el-card__header {
        padding: 10px;
    }

    .el-card__body {
        padding: 0 10px 20px;
    }

    .popover-title {
        margin: 0 0 15px 0;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100%;
    }

    .el-tag {
        margin-right: 10px;
    }
    .special-card-pay-list{
        display: flex;
        flex-wrap: wrap;
        row-gap: 6px;
    }
    .field-tip{
        margin-top: 5px;
        color: #909399;
        font-size: 12px;
        line-height: 18px;
    }
    .pre-line-text{
        white-space: pre-line;
        word-break: break-word;
    }
    .picture-requirement{
        margin-bottom: 10px;
    }
    .picture-upload-row{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
    }
    .picture-list,
    .product-picture-list{
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 10px;
    }
    .picture-item,
    .product-picture-item{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
    }
    .picture-image,
    .product-picture-image{
        width: 80px;
        height: 80px;
    }
    .picture-delete,
    .product-picture-delete{
        position: absolute;
        top: -8px;
        right: -8px;
        padding: 5px;
    }
    .production-reply{
        padding: 8px;
        border: 1px solid #e1f3d8;
        border-radius: 4px;
        background: #f0f9eb;
    }
    .el-divider__text {
        color: #209e91;
    }
    .paste-wrap{
        width: 100px;
        height: 80px;
        border: 1px dashed #209e91;
        border-radius: 4px;
        text-align: center;
        line-height: 80px;
        color: #209e91;
        cursor: pointer;
        outline: none;
    }
    .paste-wrap:focus{
        background: #f0f9eb;
        border-style: solid;
    }
    @media (max-width: 768px){
        .ai-draft-header{
            align-items: flex-start;
        }
        .ai-draft-subtitle{
            display: block;
            margin: 4px 0 0;
        }
        .ai-draft-actions .el-button{
            margin-left: 0;
        }
    }
}
</style>
